import React, { Component } from 'react';
import Footer from '../components/Footer';
import * as Common from '../components/Common';

class Introduce extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bannerList: null
    };
  }

  componentDidMount() {
    this._getBanners();
  }

  /**
   * 배너조회
   */
  _getBanners() {
    Common.callApi('/banners', 'get', {bannerType: 'LIST', branchType: 'StudyTOZ', platform: 'MOBILE'})
    .then(result => {
      var _resultDataList = result.resultDataList;
      if(_resultDataList != null && _resultDataList.length > 0) {
        this.setState({ bannerList: _resultDataList });
      }
    });
  }

  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont" >
              <div id="contents">
                <div className="app-header">
                  <p className="app-logo" onClick={() => {window.location.href = '/'}}><span className="blind">TOZ StudyCenter</span></p>
                  <a href="/" className="app-close"><span className="blind">닫기</span></a>
                </div>

                <div className="info-cont">

                  <ul className="info-main">
                    <li className="menu01 line02">
                      <a href="/introduce01">
                        <span className="num">01</span>
                        <span className="stxt">학습유형에 따른 토즈만의</span>
                        <span className="btxt">5가지 학습공간</span>
                      </a>
                    </li>
                    <li className="menu02 line02">
                      <a href="/introduce02">
                        <span className="num">02</span>
                        <span className="stxt">토즈만의 전문적인</span>
                        <span className="btxt">관리 서비스</span>
                      </a>
                    </li>
                    <li className="menu03 line01">
                      <a href="/introduce03">
                        <span className="num">03</span>
                        <span className="btxt">등록 안내 및 문의</span>
                      </a>
                    </li>
                    <li className="menu04 line01">
                      <a href="/introduce04">
                        <span className="num">04</span>
                        <span className="btxt">고객센터</span>
                      </a>
                    </li>

                    { this.state.bannerList ? this.state.bannerList.map((entity, index) => <li key={index} className="line03" style={{ backgroundImage: 'url(' + entity.bannerImgUrl + ')',  backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'cover' }}><a href={null} onClick={() => Common.doMoveBannerLink(entity)}></a></li>) : "" }
                  </ul>

                </div>

                <Footer />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Introduce;